export const VOICE_OPTIONS = [
  { value: 'aura-asteria-en', label: 'Asteria (female) Aura 1' },
  { value: 'aura-luna-en', label: 'Luna (female) Aura 1' },
  { value: 'aura-stella-en', label: 'Stella (female) Aura 1' },
  { value: 'aura-athena-en', label: 'Athena (female) Aura 1' },
  { value: 'aura-hera-en', label: 'Hera (female) Aura 1' },
  { value: 'aura-angus-en', label: 'Angus (male) Aura 1' },
  { value: 'aura-arcas-en', label: 'Arcas (male) Aura 1' },
  { value: 'aura-helios-en', label: 'Helios (male) Aura 1' },
  { value: 'aura-orion-en', label: 'Orion (male) Aura 1' },
  { value: 'aura-orpheus-en', label: 'Orpheus (male) Aura 1' },
  { value: 'aura-perseus-en', label: 'Perseus (male) Aura 1' },
  { value: 'aura-zeus-en', label: 'Zeus (male) Aura 1' },
  {
    value: 'aura-2-amalthea-en',
    label: 'Amalthea (female) Aura 2',
  },
  {
    value: 'aura-2-andromeda-en',
    label: 'Andromeda* (female) Aura 2',
  },
  {
    value: 'aura-2-asteria-en',
    label: 'Asteria (female) Aura 2',
  },
  {
    value: 'aura-2-athena-en',
    label: 'Athena (female) Aura 2',
  },
  {
    value: 'aura-2-aurora-en',
    label: 'Aurora (female) Aura 2',
  },
  {
    value: 'aura-2-callista-en',
    label: 'Callista (female) Aura 2',
  },
  {
    value: 'aura-2-cora-en',
    label: 'Cora (female) Aura 2',
  },
  {
    value: 'aura-2-cordelia-en',
    label: 'Cordelia (female) Aura 2',
  },
  {
    value: 'aura-2-delia-en',
    label: 'Delia (female) Aura 2',
  },
  {
    value: 'aura-2-electra-en',
    label: 'Electra (female) Aura 2',
  },
  {
    value: 'aura-2-harmonia-en',
    label: 'Harmonia (female) Aura 2',
  },
  {
    value: 'aura-2-helena-en',
    label: 'Helena* (female) Aura 2',
  },
  {
    value: 'aura-2-hera-en',
    label: 'Hera (female) Aura 2',
  },
  {
    value: 'aura-2-iris-en',
    label: 'Iris (female) Aura 2',
  },
  {
    value: 'aura-2-janus-en',
    label: 'Janus (female) Aura 2',
  },
  {
    value: 'aura-2-juno-en',
    label: 'Juno (female) Aura 2',
  },
  {
    value: 'aura-2-luna-en',
    label: 'Luna (female) Aura 2',
  },
  {
    value: 'aura-2-minerva-en',
    label: 'Minerva (female) Aura 2',
  },
  {
    value: 'aura-2-ophelia-en',
    label: 'Ophelia (female) Aura 2',
  },
  {
    value: 'aura-2-pandora-en',
    label: 'Pandora (female) Aura 2',
  },
  {
    value: 'aura-2-phoebe-en',
    label: 'Phoebe (female) Aura 2',
  },
  {
    value: 'aura-2-selene-en',
    label: 'Selene (female) Aura 2',
  },
  {
    value: 'aura-2-thalia-en',
    label: 'Thalia* (female) Aura 2',
  },
  {
    value: 'aura-2-theia-en',
    label: 'Theia (female) Aura 2',
  },
  {
    value: 'aura-2-vesta-en',
    label: 'Vesta (female) Aura 2',
  },
  {
    value: 'aura-2-apollo-en',
    label: 'Apollo* (male) Aura 2',
  },
  {
    value: 'aura-2-arcas-en',
    label: 'Arcas* (male) Aura 2',
  },
  {
    value: 'aura-2-atlas-en',
    label: 'Atlas (male) Aura 2',
  },
  {
    value: 'aura-2-draco-en',
    label: 'Draco (male) Aura 2',
  },
  {
    value: 'aura-2-hermes-en',
    label: 'Hermes (male) Aura 2',
  },
  {
    value: 'aura-2-hyperion-en',
    label: 'Hyperion (male) Aura 2',
  },
  {
    value: 'aura-2-jupiter-en',
    label: 'Jupiter (male) Aura 2',
  },
  {
    value: 'aura-2-mars-en',
    label: 'Mars (male) Aura 2',
  },
  {
    value: 'aura-2-neptune-en',
    label: 'Neptune (male) Aura 2',
  },
  {
    value: 'aura-2-odysseus-en',
    label: 'Odysseus (male) Aura 2',
  },
  {
    value: 'aura-2-orion-en',
    label: 'Orion (male) Aura 2',
  },
  {
    value: 'aura-2-orpheus-en',
    label: 'Orpheus (male) Aura 2',
  },
  {
    value: 'aura-2-pluto-en',
    label: 'Pluto (male) Aura 2',
  },
  {
    value: 'aura-2-saturn-en',
    label: 'Saturn (male) Aura 2',
  },
  {
    value: 'aura-2-zeus-en',
    label: 'Zeus (male) Aura 2',
  },
];
